<template>
  <div class="thread">
    <div class="post-btn" v-if="user && Object.keys(user).length > 0 && (!topic.status || topic.status != 'ARCHIVE')">
      <el-button type="primary" v-if="user && user.postStatus != 'CLOSED'" @click="replyClick">回复</el-button>
    </div>

    <div v-if="loading">
      <PostCardLoading />
    </div>
    <div v-else>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :hide-on-single-page="true"
      />

      <div v-if="topic != null && currentPage === 1">
        <PostCard
          :values="topic"
          type="topic"
          :floor="1"
          :currentPage="currentPage"
          @image-clicked="handleImgClick"
        />
      </div>

      <div v-for="(item, index) in replies" :key="item.id">
        <PostCard
          :values="item"
          type="reply"
          :topic="topic"
          :floor="(currentPage - 1) * pageSize + index + 2"
          :currentPage="currentPage"
          @image-clicked="handleImgClick"
        />
      </div>

      <ImagePreview
        :imgList="previewList"
        ref="childRef"/>

      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :hide-on-single-page="true"
      />
    </div>

    <div class="post" v-if="topic && topic.status && topic.status == 'ARCHIVE'">
      <div
        class="reminder-box"
      >
        <ul>
          <li>
           此贴已经
            <span class="highlight" 
              >归档</span
            >,无法回复
            。
          </li>
         
        </ul>
      </div>
    </div>

    <div class="post" v-else>
      <div class="reminder-box"         
      v-if="
          user &&
          Object.keys(user).length > 0 &&
          type != 'comment' &&
          type != 'post_comment' &&
          user.postStatus == 'CLOSED'
        ">
        <ul>
          <li>根据相关法律法规，您需要完成真实身份核验后方可使用发帖、回复、评论等功能。</li>
          <li>你可以通过以下方式完成实名制认证。</li>
          <li><router-link class="highlight" to="/my?tab=bind">身份信息认证</router-link></li>
          
          <!-- 提示海外用户的 -->
          <li>Hello, this community currently does not support registration with non-Mainland China mobile phone numbers.</li>
          <li>You can send an email to <span class="highlight">tech@wch.cn</span> to consult about technical issues you encounter.</li>
          <li>Community posts can be viewed and searched without account authentication.</li>

        </ul>
      </div>
      <div v-else>
        <Editor btn="回复" :values="{}" />
      </div>
    </div>
  </div>
</template>

<script>
import { getPost, saveReply } from "@/service/post";
import PostCard from "@/components/PostCard";
import Editor from "@/components/Editor";
import UserAvatar from "@/components/UserAvatar";
import { mapGetters } from "vuex";
import PostCardLoading from "@/components/PostCardLoading";
import ImagePreview  from "@/components/Images";
export default {
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content: this.description ? this.description : "",
        },
      ],
    };
  },
  data() {
    return {
      loading: true,
      topic: null,
      description: null,
      replies: null,
      total: 0,
      pageSize: 10,
      currentPage: 1,
      previewList: []
    };
  },
  computed: {
    ...mapGetters(["menu", "user"]),
  },
  components: {
    PostCard,
    UserAvatar,
    Editor,
    PostCardLoading,
    ImagePreview
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  created() {
   // console.info("created");
    this.fetchData();
    //console.debug("user", this.user);
  },
  watch: {
    $route() {
      this.fetchData();
      //console.info('watch',this.user)
    },
  },
  methods: {
    handleImgClick(imageUrl) {
      console.log('====================子组件传过来的值',imageUrl)
      // 清空并添加单个值（一步完成）
      this.previewList = [imageUrl];
      this.$refs.childRef.showImgViewer();
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal(，否则会报错
    },
    replyClick() {
      const targetHash = "#reply-content";
      if (window.location.hash === targetHash) {
        window.location.hash = "#temp - hash";
      }
      window.location.hash = targetHash;
    },
    handleCurrentChange(current) {
      const id = this.$route.params.id ? this.$route.params.id : -1;
      this.$router.push(
        `thread-${id}-${current}.html?time=` +
          this.$dayjs().format("YYYYMMDDHHmmssSSS")
      );
    },

    fetchData() {
      const id = this.$route.params.id ? this.$route.params.id : -1;
      const current = this.$route.params.current
        ? this.$route.params.current
        : 1;

      getPost(id, current)
        .then((response) => {
          console.debug("response", response);
          if (response.code === 0) {

            // 判断data的值是否为空的

            if(response.data){
              this.topic = response.data.topic;
              if(this.topic.postType && this.topic.postType === 'article'){
                this.$router.push(`/article/${this.topic.user.id}/${id}.html`);
              }
              this.description = this.topic.description;
              this.replies = response.data.replies.records;
              this.total = response.data.replies.total;
              this.pageSize = response.data.replies.size;
              this.currentPage = response.data.replies.current;
              this.$store.dispatch("app/setBreadcrumb", [
                {
                  key: 1,
                  link: "/forums/" + this.topic.community.aliase + ".html",
                  value: this.topic.community.name,
                },
                {
                  key: 2,
                  link: "/forum-" + this.topic.forum.id + "-1.html",
                  value: this.topic.forum.name,
                },
                {
                  key: 3,
                  link: "/thread-" + id + "-1.html",
                  value: this.topic.title,
                },
              ]);
              this.loading = false;
            }else{
              this.$router.push("/404.html");
            }
          }
        })
        .catch((error) => {
          console.error("er2", error);
        });
    },
  },
};
</script>

<style lang="less">
.post-btn {
  margin-bottom: 10px;
  text-align: left;
}
.up {
  height: 100%;
  width: 100%;
  background-color: #f2f5f6;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  text-align: center;
  line-height: 40px;
  color: #1989fa;
}
.topic-item {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  border-bottom: 1px dashed #969696;
  min-height: 52px;
  display: flex;
  &:last-child {
    border-bottom: none !important;
  }
}

.topic-item-value {
  // width: 500px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.topic-item-value-data {
  margin-top: 5px;
}

.topic-item-ext {
  width: 400px;
  display: flex;
  justify-content: flex-end;
}
.el-pagination {
  margin-top: 10px;
  margin-bottom: 10px;
}

.post {
  background-color: #fff;
  border: 1px solid #969696;
}
</style>
